import FBPNAutocomplete from './FBPNAutocompleteConnector';

export default FBPNAutocomplete;
